export default __webpack_public_path__ + "static/misson_mob-6f1b325f7f434a5415732d4cfb9abec6.png";